import { MinzeElement } from 'minze'

export class LvcTabNextIcon extends MinzeElement {
  html = () => `
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="20" y="20.5" width="20" height="20" rx="10" transform="rotate(-180 20 20.5)" fill="#1E007D"/>
<path d="M8.7998 14.0999C9.69528 13.1502 10.7233 12.1055 11.6531 10.9728C11.8633 10.7168 11.8779 10.3528 11.6875 10.0817C10.8548 8.8968 10.0259 8.01147 8.88384 6.8999" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  `
}
